import React from 'react';
import styled from '@emotion/styled';

const JVPContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

const ContentBox = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  gap: 20px;
  width: 100%;
  background: #FFFFFF;
  border: 1px solid #C5C5C6;
  border-radius: 12px;
`;

const Title = styled.h3`
  font-family: 'Sofia Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #2C2C2D;
`;

const CheckboxGroup = styled.div`
  display: flex;
  gap: 24px;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  font-family: 'Sofia Sans', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #2C2C2D;
  cursor: pointer;
`;

const Checkbox = styled.input`
  width: 16px;
  height: 16px;
  margin-right: 8px;
  cursor: pointer;
`;

const JVP = ({ data, onChange }) => {
  const handleChange = (side) => {
    onChange({
      ...data,
      [side]: !data[side]
    });
  };

  return (
    <JVPContainer>
      <ContentBox>
      
        <CheckboxGroup>
          <CheckboxLabel>
            <Checkbox
              type="checkbox"
              checked={data.left}
              onChange={() => handleChange('left')}
            />
            Left
          </CheckboxLabel>
          <CheckboxLabel>
            <Checkbox
              type="checkbox"
              checked={data.right}
              onChange={() => handleChange('right')}
            />
            Right
          </CheckboxLabel>
        </CheckboxGroup>
      </ContentBox>
    </JVPContainer>
  );
};

export default JVP;
